import { useContext } from "react";
import { UserContext } from "../../Context/UserContextAPI";

const HeaderImg = () => {
  const { settingsData } = useContext(UserContext);
  return (
    <div className=" text-dark">
      <div className="text-center patient-invoice-header-middle">
        <div className="">
          <img
            src={`${process.env.REACT_APP_UPLOAD_URL}/${settingsData?.header_image}`}
            alt="Report Header"
            className="mx-auto"
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};
export default HeaderImg;
